import React from 'react';
import {Route, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {toggleCollapsedNav} from 'actions/index';
import Header from 'components/Header/index';
import Sidebar from 'containers/SideNav/index';
import Components from './routes/components';
import Extensions from './routes/extensions';
import Map from './routes/map';
import AppModule from './routes/appModule';
import {COLLAPSED_DRAWER, FIXED_DRAWER} from 'constants/ActionTypes';
import {isIOS, isMobile} from 'react-device-detect';
import asyncComponent from '../util/AsyncFunc';

class App extends React.Component {
    onToggleCollapsedNav = () => {
        const val = !this.props.navCollapsed;
        this.props.toggleCollapsedNav(val);
    };

    render() {
        const {match, drawerType} = this.props;
        const drawerStyle = drawerType.includes(FIXED_DRAWER) ? 'fixed-drawer' : drawerType.includes(COLLAPSED_DRAWER) ? 'collapsible-drawer' : 'mini-drawer';

        // set default height and overflow for iOS mobile Safari 10+ support.
        if (isIOS && isMobile) {
            $('#body').addClass('ios-mobile-view-height');
        }
        else if ($('#body').hasClass('ios-mobile-view-height')) {
            $('#body').removeClass('ios-mobile-view-height');
        }

        return (
                <div className={`app-container ${drawerStyle}`}>


                    <Sidebar onToggleCollapsedNav={this.onToggleCollapsedNav.bind(this)}/>
                    <div className="app-main-container">
                        <div className="app-header">
                            <Header drawerType={drawerType} onToggleCollapsedNav={this.onToggleCollapsedNav}/>
                        </div>

                        <main className="app-main-content-wrapper">
                            <div className="app-main-content">

                                <Route path={`${match.url}/components`} component={Components}/>
                                <Route path={`${match.url}/extensions`} component={Extensions}/>
                                <Route path={`${match.url}/map`} component={Map}/>
                                <Route
                                    path={`${match.url}/widgets`}
                                    component={asyncComponent(() => import('./routes/widgets'))}
                                />
                                <Route
                                    path={`${match.url}/metrics`}
                                    component={asyncComponent(() => import('./routes/metrics'))}
                                />
                                <Route path={`${match.url}/app-module`} component={AppModule}/>
                                <Route
                                    path={`${match.url}/contact`}
                                    component={asyncComponent(() => import('./routes/contact/basic/index'))}
                                />
                                <Route
                                    path={`${match.url}/contact-redux`}
                                    component={asyncComponent(() => import('./routes/contact/redux/index'))}
                                />
                            </div>

                        </main>
                    </div>

                </div>

        );
    }
}


const mapStateToProps = ({settings}) => {
    const {navCollapsed, drawerType} = settings;
    return {navCollapsed, drawerType};
};
export default withRouter(connect(mapStateToProps, {toggleCollapsedNav})(App));



// WEBPACK FOOTER //
// ./app/index.js